export const getMemberList = IdList => {
  return `
          SELECT
            Id,
            Name,
            Name__c,
            Time__c,
            Nome_do_Outlook__c,
            Email_do_SalesForce__c,
            Mesa_Opera_o__c,
            Mesa_Opera_o__r.Name,
            Mesa_Opera_o__r.Id,
            Mesa_Opera_o__r.Lider__c,
            Mesa_Opera_o__r.Lider__r.Nome_do_Outlook__c,
            Mesa_Opera_o__r.Lider__r.Email_do_Salesforce__c,
            Mesa_Opera_o__r.Lider__r.Name,
            Canal_de_Atendimento__c,
            Status__c
          FROM
            Membros__c
          WHERE
            Id IN (${IdList.map(id => `'${id}'`).join(', ')})
        `;
};
